<template>
  <ModalWrapper
    modalName="deleteConfirmModal"
    maxWidth="max-w-2xl"
    :closeButton="false"
  >
    <div class="">
      <div class="w-full">
        <p
          class="mb-4 text-center text-22 font-medium text-primary-100 lg:text-left lg:text-2xl"
        >
          {{ title }}
        </p>
      </div>

      <span v-html="text"></span>

      <div>
        <div
          class="mt-4 flex items-center justify-center space-x-8 text-sm md:justify-end"
        >
          <button
            @click="onClickCancel"
            class="transition-ease-in-out font-semibold text-primary-main hover:text-primary-light"
          >
            {{ $t("action.cancel") }}
          </button>

          <Button
            theme="secondary"
            class="text-yellow-50 relative w-40 bg-danger-100 px-4 py-2"
            @click="onClickConfirm"
          >
            {{ $t("action.confirm") }}
          </Button>
        </div>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import isMobile from "@/mixins/isMobile";
import ModalWrapper from "@/components/Core/ModalWrapper.vue";
import Button from "@/components/Core/ButtonBase.vue";

export default {
  name: "DeleteConfirmModal",
  components: {
    ModalWrapper,
    Button,
  },
  mixins: [isMobile],
  computed: {
    confirm() {
      return this.getModalData("deleteConfirmModal").onConfirm;
    },
    cancel() {
      return this.getModalData("deleteConfirmModal").onCancel;
    },
    title() {
      return this.getModalData("deleteConfirmModal").title;
    },
    text() {
      return this.getModalData("deleteConfirmModal").text;
    },
    ...mapGetters({ getModalData: "modals/getModalData" }),
  },
  methods: {
    onClickCancel() {
      this.cancel();
      this.closeModal("deleteConfirmModal");
    },
    onClickConfirm() {
      this.confirm();
      this.closeModal("deleteConfirmModal");
    },
    ...mapMutations({
      closeModal: "modals/closeModal",
    }),
  },
};
</script>
